<template>
  <div class="lobby-container">
    <div class="home-card">
      <h1>Welcome to the Online ToepApp!</h1>
      <router-link to="/lobby" class="button">Go to Lobby</router-link>
    </div>
  </div>
</template>

<script>
import storage from '@/utility/storage.js'
import { v4 as uuidv4 } from 'uuid'
import { SocketManager } from '@/utility/SocketManager.js'
export default {
  name: 'HomePage',
  inject: ['socket'],
  data() {
    return {
      socketManager: null,
      gameId: storage.get('gameId') || null,
      playerId: storage.get('playerId') || uuidv4(),
      userName: storage.get('userName') || null,
    }
  },
  mounted() {
    this.socketManager = new SocketManager(this.socket)

    storage.set('playerId', this.playerId)

    this.socketManager.onSocketEvent('connect', () => {
      if (!this.userName || !this.gameId) {
        console.error('Missing username or game ID!')
        return
      }

      this.socketManager.emitSocketEvent(
        'connected',
        { playerId: this.playerId, roomId: this.gameId },
        (res) => {
          if (!res) {
            console.error('Failed to connect to the game!')
            return
          }
        }
      )
    })

    this.socketManager.onSocketEvent('reconnected', () => {
      console.log('Reconnected to the server!')
      this.$router.push({
        path: `/game/${this.gameId}`,
      })
    })
  },
  beforeUnmount() {
    this.socketManager.offSocketEvent('connect')
    this.socketManager.offSocketEvent('reconnected')
  },
}
</script>

<style scoped>
/* Card-like container */
.home-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 80%;
}

/* Title */
.home-card h1 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 10px;
}

/* Subtitle */
.subtitle {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 20px;
}

/* Responsive Design */
@media (max-width: 600px) {
  .home-card {
    padding: 20px;
  }
}
</style>
